import React from "react";
import { Box, Fade } from "@mui/material";
import { styled } from "@mui/material/styles";

import whirls from "../../assets/background-whirls.png";
import Studio3TLogo from "../../assets/Studio3TLogo";

const Container = styled(Box)(({ theme }) => ({
	height: "100%",
	padding: "0 20px",
	backgroundImage: `url(${whirls})`,
	"background-position-y": "120px",
	"background-position-x": "center",
	backgroundRepeat: "no-repeat",
	backgroundSize: "1440px 488px",
}));

const LogoContainer = styled(Box)(({ theme }) => ({
	marginTop: "30px",
	marginBottom: "40px",
}));

export const PageContainer = ({ children, additionalLogoSx, className }) => {
	return (
		<Container>
			<Fade in timeout={300}>
				<Box>
					<Box display="flex" justifyContent="center">
						<LogoContainer
							sx={{
								...additionalLogoSx,
							}}
							className={className}
						>
							<Studio3TLogo />
						</LogoContainer>
					</Box>
					{children}
				</Box>
			</Fade>
		</Container>
	);
};
